/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./success.css";
import { useLocation, useParams } from "react-router-dom";
import { axiosInstance } from "../../Axios/https";

const Success = () => {
  
  const location = useLocation();
  const params = useParams();
  const searchParams = new URLSearchParams(location?.search);
  const paymentId = searchParams.get("paymentId");
  const PayerId = searchParams.get("PayerID");
  const planID = params;
  const userId = params;
  const { "*": three } = userId;
  const splits = three.split("/");

  useEffect(() => {
    if (planID?.param1 && splits[0]) {
      const formData = new FormData();
      formData.append("paymentId", paymentId);
      formData.append("PayerID", PayerId);
      axiosInstance
        .post(`payment/success/${planID?.param1}/${splits[0]}`, formData)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [planID?.param1, splits[0]]);

  return (
    <>
      <div className="success">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-5">
              <div class="message-box _success">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <h2> Your payment was successful </h2>
                <p>
                  {" "}
                  Thank you for your payment. we will <br />
                  be in contact with more details shortly{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Success;
